<template>
    <div :class="{ 'program-item-hero': true }">
        <div
            role="image"
            class="poster"
            :style="{
                'background-image':
                    (item.displayPosterTitle
                        ? 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7707457983193278) 50%, rgba(0,0,0,0) 100%), '
                        : '') +
                    'url(&quot;' +
                    item.fhdImage +
                    '&quot;)',
            }"
        ></div>
        <div
            class="hero-details"
            :class="(item.type === 'group' ? 'group' : 'video') + '-details'"
        >
            <h2 v-if="item.displayPosterTitle" class="title">
                {{ item.title }}
            </h2>
            <h3 v-if="item.displayPosterTitle" class="sub-title">
                {{ item.subtitle || '&nbsp;' }}
            </h3>
            <div
                v-if="item.displayPosterTitle && (item.title || item.subtitle)"
                class="video-info"
            >
                <h6
                    v-if="showViews && item.type !== 'group'"
                    class="video-views video-info-item"
                >
                    {{ formattedViews }}
                    {{ item.type === 'audio' ? 'listens' : 'views' }}
                </h6>
                <span
                    v-if="showViews && showDate && item.type !== 'group'"
                    class="dot"
                    >•</span
                >
                <h6
                    v-if="showDate && item.type !== 'group'"
                    class="video-date video-info-item"
                >
                    {{ formattedDate }}
                </h6>
                <span
                    v-if="
                        showViews &&
                        showDate &&
                        item.type !== 'group' &&
                        !item.scheduleId &&
                        !item.live
                    "
                    class="dot"
                    >•</span
                >
                <h6
                    v-if="
                        item.type !== 'group' && !item.scheduleId && !item.live
                    "
                    class="time video-info-item"
                >
                    {{ formattedTime }}
                </h6>
            </div>

            <!-- eslint-disable-next-line -->
            <p v-if="item.displayPosterTitle" class="description" v-html="safeDescription"></p>

            <div class="btn-container">
                <router-link
                    v-if="item.type !== 'group' && behavior === 'disallow'"
                    class="btn"
                    to="/subscribe"
                    >{{
                        item.type === 'audio'
                            ? subscribeText.replace(/watch/i, 'Listen')
                            : subscribeText
                    }}</router-link
                >
                <router-link
                    v-else-if="item.type === 'video'"
                    class="btn"
                    :to="link"
                    >Watch Now</router-link
                >
                <router-link
                    v-else-if="item.type === 'audio'"
                    class="btn"
                    :to="link"
                    >Listen Now</router-link
                >
                <router-link v-else-if="link" class="btn" :to="link"
                    >Start Watching</router-link
                >
                <router-link
                    v-for="(exlink, i) in item.links"
                    :key="i"
                    class="btn"
                    :to="exlink.url"
                    >{{ exlink.text }}</router-link
                >
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import 'moment-duration-format';
import '@/icons/gideo_play';
import '@/icons/arrow_forward';

export default {
    name: 'ProgramItemHeroPoster',
    props: {
        item: {
            type: Object,
            required: true,
        },
        showDate: {
            type: Boolean,
            default: false,
        },
        showViews: {
            type: Boolean,
            default: false,
        },
        subscribeText: {
            type: String,
            default: 'Subscribe To Watch',
        },
    },
    computed: {
        behavior: function () {
            const behavior = this.$gideo.subscriber
                ? 'subscriberBehavior'
                : 'freeBehavior';
            return this.item[behavior];
        },
        safeDescription: function () {
            //this is now handled in the xml parser
            let description = this.item.webDescription || this.item.description;
            description = description || '';
            description = description.replace(
                /<\s*img(.*?)<\/\s*img\s*>/gm,
                '',
            );
            return description.replace(/<\s*script(.*?)<\/\s*script\s*>/gm, '');
        },
        formattedTime: function () {
            if (this.item.length > 60) {
                return moment
                    .duration(this.item.length, 'seconds')
                    .format('h[h] m[m]');
            }

            return moment.duration(this.item.length, 'seconds').format('s[s]');
        },
        formattedDate: function () {
            return moment(this.item.added).fromNow();
        },
        formattedViews: function () {
            let suffixes = ['', 'k', 'm', 'b', 't'];
            let suffixNum = Math.floor((('' + this.item.views).length - 1) / 3);
            let shortValue = parseFloat(
                (suffixNum != 0
                    ? this.item.views / Math.pow(1000, suffixNum)
                    : this.item.views
                ).toPrecision(2),
            );
            if (shortValue % 1 != 0) {
                shortValue = shortValue.toFixed(1);
            }
            return shortValue + suffixes[suffixNum];
        },
        link: function () {
            if (this.item.type === 'group') {
                return {
                    name: 'program-group',
                    params: {
                        groupId: this.item.id,
                    },
                };
            } else {
                return {
                    name: 'program',
                    params: {
                        groupId: this.item.parentId,
                        programId: this.item.id,
                    },
                };
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '../assets/css/_variables.scss';

.program-item-hero {
    height: 100%;
    display: flex;
    align-content: left;
    text-align: left;
    font-size: 1.5rem;
    padding: 3em;
    z-index: 0;
    transition:
        transform 0.3s ease-in-out 0s,
        z-index 0.5s linear 1s;

    @media (min-width: 600px) {
        font-size: 1.5rem;
    }
    @media (min-width: 1280px) {
        font-size: 2rem;
    }
    .hero-details {
        width: 100%;
        text-align: center;
        position: relative;
        @media (min-width: 600px) {
            width: 85%;
        }
        @media (min-width: 1280px) {
            width: 50%;
        }
    }
    .title {
        font-size: 2em;
        font-weight: 500;
        line-height: 1.1em;
        text-align: left;
        margin: 0 0 0.1em;
        opacity: 0;
        transition: opacity 0.3s;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        max-height: 4.4em;
        overflow: hidden;
        @media (min-width: 600px) {
            font-size: 2.2em;
            -webkit-line-clamp: 2;
            max-height: 2.2em;
        }
    }
    .sub-title {
        width: 100%;
        font-size: 1.1em;
        font-weight: 500;
        line-height: 1.1em;
        text-align: left;
        margin: 0 0 0.1em;
        float: left;
        opacity: 0;
        transition: opacity 0.3s;
    }
    .group-details {
        .sub-title {
            margin-bottom: 1em;
        }
    }
    .video-info {
        text-align: left;
        width: 100%;
        opacity: 0;
        transition: opacity 0.3s;
    }
    .video-info-item {
        font-size: 1em;
        line-height: 1.1em;
        margin: 0;
        margin: 0 0.4em 0.8em 0.4em;
        opacity: 0.7;
        display: inline-block;
        opacity: 0.7;
        @media (min-width: 600px) {
            font-size: 1.1em;
        }
        &:first-child {
            margin-left: 0;
        }
    }
    .dot {
        font-size: 1.1em;
        line-height: 1.1em;
        opacity: 0.7;
    }

    p {
        width: 100%;
        font-size: 1em;
        line-height: 1.1em;
        overflow: hidden;
        margin: 0 0 1.12em;
        text-align: left;
        opacity: 0;
        transition: opacity 0.3s;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 10;
        max-height: 11em;

        @media (min-width: 600px) {
            -webkit-line-clamp: 8;
            max-height: 8.8em;
        }
        @media (min-width: 1280px) {
            -webkit-line-clamp: 10;
            max-height: 11em;
        }
    }

    .btn-container {
        text-align: center;
        width: 100%;
        float: left;
        position: absolute;
        bottom: 0;

        .btn {
            margin: auto;
            @media (min-width: 600px) {
                margin: 0;
            }

            & + .btn {
                margin-top: 1em;
                @media (min-width: 600px) {
                    margin: 0 1em;
                }
            }
        }
    }
    .btn {
        opacity: 0;
    }

    .vueperslide--visible & {
        .title {
            opacity: 1;
            animation: enterDimContentRight 0.8s ease forwards 0.1s;
        }
        .sub-title {
            opacity: 1;
            animation: enterDimContentRight 1s ease forwards 0.1s;
        }
        .video-info {
            opacity: 1;
            animation: enterDimContentRight 1s ease forwards 0.1s;
        }
        .description {
            opacity: 1;
            animation: enterDimContentRight 1.2s ease forwards 0.1s;
        }
        .btn {
            opacity: 1;
            animation: enterDimContentRight 1.4s ease forwards 0.1s;
        }
    }

    .poster {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
    }
}
@keyframes enterDimContentRight {
    0% {
        opacity: 0;
        transform: translate3d(-4em, 0, 0);
    }

    to {
        opacity: 0.8;
        transform: translateZ(9);
    }
}
@keyframes enterDimContent {
    0% {
        opacity: 0;
    }

    to {
        opacity: 0.8;
    }
}
</style>
